'use strict';
angular.module('theme').component('integrityPolicy', {
	templateUrl: 'component/integrity-policy.html',
	controller: function($scope) {

		$scope.close = function() {
			$scope.show = false;
		};

		$scope.agree = function() {
			$scope.agreed = true;
			$scope.close();
		};
	}
});
